import {cn} from '@/lib/utils'
import React from 'react'
import {ICON_CLASSES} from './iconClasses'

export const WuText: React.FC<
  React.HTMLAttributes<HTMLParagraphElement> & {
    size?: 'sm' | 'md' | 'lg'
    as?: 'p' | 'div' | 'span'
  }
> = props => {
  const {size = 'lg', className, children, ...rest} = props
  const sizeToClass = {
    sm: 'wu-body-3',
    md: 'wu-body-2',
    lg: 'wu-body-1',
  }
  const Tag = props.as || 'div'
  return (
    <Tag {...rest} className={cn(sizeToClass[size], className)}>
      {children}
    </Tag>
  )
}

export const WuHeading: React.FC<
  React.HTMLAttributes<HTMLHeadingElement> & {size?: 'sm' | 'md' | 'lg' | 'xl'}
> = props => {
  const {size = 'xl', className, children, ...rest} = props

  const sizeToTag: Record<typeof size, 'h1' | 'h2' | 'h3' | 'h4'> = {
    sm: 'h4',
    md: 'h3',
    lg: 'h2',
    xl: 'h1',
  }

  const sizeToClass = {
    sm: 'wu-heading-4',
    md: 'wu-heading-3',
    lg: 'wu-heading-2',
    xl: 'wu-heading-1',
  }

  const Tag = sizeToTag[size]

  return (
    <Tag {...rest} className={cn(sizeToClass[size], className)}>
      {children}
    </Tag>
  )
}

export const WuSubtext: React.FC<
  React.HTMLAttributes<HTMLParagraphElement> & {
    size?: 'sm' | 'md' | 'lg'
    as?: 'p' | 'div' | 'span'
  }
> = props => {
  const {size = 'lg', className, children, ...rest} = props
  const sizeToClass = {
    sm: 'wu-subtext-3',
    md: 'wu-subtext-2',
    lg: 'wu-subtext-1',
  }
  const Tag = props.as || 'div'
  return (
    <Tag {...rest} className={cn(sizeToClass[size], className)}>
      {children}
    </Tag>
  )
}

export const WuDisplay: React.FC<
  React.HTMLAttributes<HTMLHeadingElement> & {
    size?: 'md' | 'lg'
    as?: 'h1' | 'h2' | 'h3' | 'h4' | 'div'
  }
> = props => {
  const {size = 'lg', className, children, ...rest} = props
  const sizeToClass = {
    md: 'wu-display-2',
    lg: 'wu-display-1',
  }
  const Tag = props.as || 'h1'
  return (
    <Tag {...rest} className={cn(sizeToClass[size], className)}>
      {children}
    </Tag>
  )
}
type IIcons = (typeof ICON_CLASSES)[number]
export const WuIcon: React.FC<
  React.BaseHTMLAttributes<HTMLBaseElement> & {
    icon: IIcons
  }
> = props => {
  const {icon, className, ...rest} = props
  return (
    <span className={cn(icon, className)} role="presentation" {...rest}></span>
  )
}
